import $ from 'jquery';

$(document).ready(function () {
    /*global vars*/
    /*eslint no-undef: "error"*/
    var ajaxurl = vars.ajaxurl;

    function getFilters() {
        let chosenFilters = [];

        $('form.filter-wrap .filter').find('input:checked').each(function () {
            chosenFilters.push($(this).attr("value"));
        })
        return chosenFilters;
    }

    function AjaxBlog(filtri, page) {
        $("#filtered-blog-posts").addClass("loading");
        $.ajax({
            type: "post",
            url: ajaxurl,
            data: {
                action: "returnFilteredBlog",
                ids: filtri,
                page: page,
            },
            success: function (html) {
                $("#filtered-blog-posts").removeClass("loading");
                $('#filtered-blog-posts').html(html);
            },
            error: function () {
                $("#filtered-blog-posts").removeClass("loading");
                console.log('Error');
            }
        });
    }

    function AjaxLibrary(filtri, page) {
        $("#filtered-library-posts").addClass("loading");
        $.ajax({
            type: "post",
            url: ajaxurl,
            data: {
                action: "returnFilteredLibrary",
                ids: filtri,
                page: page,
            },
            success: function (html) {
                $("#filtered-library-posts").removeClass("loading");
                $('#filtered-library-posts').html(html);
            },
            error: function () {
                $("#filtered-library-posts").removeClass("loading");
                console.log('Error');
            }
        });
    }

    function clearFilters() {
        let chosenFilters = '';
        $('.filter__single .checked').prop("checked", false);
        $('.filter__single .checked').removeClass('checked');
        $('.filter__single.checked').removeClass('checked');
        AjaxBlog(chosenFilters, 1);
        AjaxLibrary(chosenFilters, 1);
    }

    $('form.filter-wrap .filter .filter__single input:checkbox').on('click', function() {
        $(this).toggleClass('checked');
        $(this).parent().toggleClass('checked');
        let chosenFilters = getFilters();
        AjaxBlog(chosenFilters, 1);
        AjaxLibrary(chosenFilters, 1);
    });

    $('#filtered-blog-posts').on('click', '.page-numbers', function (event) {
        event.preventDefault();
        var pageNum = $(this).text();

        let chosenFilters = getFilters();
        AjaxBlog(chosenFilters, pageNum);
    });

    $('#filtered-library-posts').on('click', '.page-numbers', function (event) {
        event.preventDefault();
        var pageNum = $(this).text();

        let chosenFilters = getFilters();
        AjaxLibrary(chosenFilters, pageNum);
    });

    $(".filter-wrap .clear-filter").click(function () {
        clearFilters();
    });
});